import { TCutPanelInspectionDB } from '@monorepo/types';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectCutPanelInspectionStore = createFeatureSelector<TCutPanelInspectionDB>('CUT_PANEL_INSPECTION_DB');

export const getAllRecentRecuts = createSelector(
  selectCutPanelInspectionStore,
  (selectCutPanelInspectionStore) => selectCutPanelInspectionStore.recentRecuts.default,
);

export const getInspectionCounts = createSelector(selectCutPanelInspectionStore, (store) => store.counts);

export const getSelectedMasterCutDisplayTag = createSelector(
  selectCutPanelInspectionStore,
  (store) => store.selectedMasterCutDisplayTag,
);
